module.exports = __webpack_public_path__ + "assets/img/lopazna-m.aee6b59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/lopazna-m.jpg
// module id = xsgK
// module chunks = 0